module.exports = __webpack_public_path__ + "img/docks.f291fcb2.jpg";